/**
 * The mode-card labels ("Skat" / "Ramsch") as etchable glyph-outline SVGs — the shared
 * construction in `glyph-word.js`, whose header carries the why. Glyph data is author-extracted
 * per mode name (`game-start-mode-label-glyphs.js`, regenerated via
 * `scripts/doc-tools/extract-glyphs.py`); the names are a fixed, localized set (identical in DE
 * and EN today), so they pre-extract like the play label.
 *
 * A mode card is a PRIMARY mark on the start screen, so its label inscribes as part of the card
 * rather than fading up — the panel-etch gesture writes frame → surface → icon → label as one
 * inscribed unit.
 */
import { MODE_LABEL_GLYPHS } from "./game-start-mode-label-glyphs.js";
import { buildGlyphWordSvg } from "../glyph-word.js";

/**
 * The label SVG for `word`, one filled <path> per letter in `inkColor`. Returns null when `word`
 * has no extracted glyph set (a language added without its glyphs) — the caller falls back to a
 * plain text label, which then blooms with the card instead of inscribing.
 */
export function buildModeLabelSvg(word, inkColor) {
  const data = MODE_LABEL_GLYPHS[word];
  if (data == null) return null;
  return buildGlyphWordSvg(data, inkColor, {
    className: "mode-label-text",
    ariaLabel: word,
  });
}
